exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TabContent__tab-pane-content___16rXP{width:100%;height:100%;flex:none;transition:opacity 0.45s;overflow:scroll;overflow-x:hidden}.TabContent__tab-pane-content--inactive___3qZmV{opacity:0}.TabContent__tab-pane-content--active___2F0c8{opacity:1}\n", ""]);

// Exports
exports.locals = {
	"tab-pane-content": "TabContent__tab-pane-content___16rXP",
	"tab-pane-content--inactive": "TabContent__tab-pane-content--inactive___3qZmV",
	"tab-pane-content--active": "TabContent__tab-pane-content--active___2F0c8"
};